/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./carrerChange.vue?vue&type=template&id=a2de1d9a&scoped=true&"
import script from "./carrerChange.vue?vue&type=script&lang=js&"
export * from "./carrerChange.vue?vue&type=script&lang=js&"
import style0 from "./carrerChange.vue?vue&type=style&index=0&id=a2de1d9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2de1d9a",
  null
  
)

export default component.exports